import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Stack,
} from "@mui/material";
import chatImage from "./firstCardImg.gif"; // Replace with actual image path
import analyticsImage from "./secondCardImg.gif"; // Replace with actual image path

const Section11B2 = ({ data, index }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        // px: { xs: 2, md: 5 },
        py: 2,
      }}
    >
      <Grid
        container
        spacing={2}
        sx={{
          width: { xl: "73%", lg: "91%" },
          // border: "1px solid red",
          justifyContent: { xs: "center", md: "space-between" },
          flexDirection: { xs: "column", md: "row" }, // Stack cards for mobile, row for larger screens
        }}
      >
        {/* First Card - Adjusted for Mobile */}
        <Grid
          item
          xs={12}
          md={6}
          xl={7}
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Card
            sx={{
              display: "flex",
              flexDirection: "column", // Stacked layout for mobile
              alignItems: "center",
              boxShadow: "none",
              border: "1px solid #E0E0E0",
              padding: "16px",
              backgroundColor: "#F9F9FF",
              height: { xs: "auto", xl: "100%" }, // Auto height for mobile, full height for larger screens
              textAlign: { xs: "center", md: "left" }, // Center-align text for mobile
            }}
          >
            <CardContent
              sx={{
                width: "100%",
                paddingBottom: "16px",
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontWeight: "bold",
                  marginBottom: "8px",
                  textAlign: { xs: "center", md: "left" }, // Center-align for mobile
                }}
              >
                {/* Real-Time Analytics */}
                {data[index]?.features[2]?.title}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  marginBottom: "16px",
                  textAlign: { xs: "center", md: "left" }, // Center-align for mobile
                }}
              >
                {/* Track your campaign results in real-time. */}
                {data[index]?.features[2]?.description1}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  marginBottom: "16px",
                  textAlign: { xs: "center", md: "left" }, // Center-align for mobile
                }}
              >
                {/* Monitor Read, Replied & Clicked rates for each campaign and
                retarget smartly for higher conversions! */}
                {data[index]?.features[2]?.description2}
              </Typography>
            </CardContent>
            <CardMedia
              component="img"
              // image={chatImage}
              image={data[index]?.features[2]?.img}
              alt="Build no-code Chatbot"
              sx={{
                width: "100%",
                height: "auto",
                borderRadius: "8px",
                marginTop: { xs: "16px", md: "0" }, // Add margin on mobile for spacing
              }}
            />
          </Card>
        </Grid>

        {/* Second Card */}

        <Grid
          item
          xs={12}
          md={6}
          xl={5}
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Card
            sx={{
              display: "flex",
              flexDirection: "column", // Stacked layout for mobile
              alignItems: "center",
              boxShadow: "none",
              border: "1px solid #E0E0E0",
              padding: "16px",
              backgroundColor: "#F9F9FF",
              height: { xs: "auto", xl: "100%" }, // Auto height for mobile, full height for larger screens
              textAlign: { xs: "center", md: "left" }, // Center-align text for mobile
            }}
          >
            <CardContent
              sx={{
                width: "100%",
                paddingBottom: "16px",
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontWeight: "bold",
                  marginBottom: "8px",
                  textAlign: { xs: "center", md: "left" }, // Center-align for mobile
                }}
              >
                {/* Real-Time Analytics */}
                {data[index]?.features[3]?.title}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  marginBottom: "16px",
                  textAlign: { xs: "center", md: "left" }, // Center-align for mobile
                }}
              >
                {/* Track your campaign results in real-time. */}
                {data[index]?.features[3]?.description1}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  marginBottom: "16px",
                  textAlign: { xs: "center", md: "left" }, // Center-align for mobile
                }}
              >
                {/* Monitor Read, Replied & Clicked rates for each campaign and
                retarget smartly for higher conversions! */}
                {data[index]?.features[3]?.description2}
              </Typography>
            </CardContent>
            <CardMedia
              component="img"
              // image={chatImage}
              image={data[index]?.features[3]?.img}
              alt="Build no-code Chatbot"
              sx={{
                width: { xs: "90%", md: "80%" }, // Responsive width
                height: { xs: "auto", md: "60%" }, // Responsive height
                borderRadius: "8px",
                marginTop: { xs: "16px", md: "0" }, // Add margin on mobile for spacing
              }}
            />
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Section11B2;
